export const SET_DATA_VERIFY = 'SET_DATA_VERIFY';

export function setDataVerify(dataVerify) {
    return {
        type: SET_DATA_VERIFY,
        dataVerify: dataVerify
    }
}